<template>
  <div class="enterprise-list-page enterprise-list-page--doctor-treatments">

    <!-- Header Card -->
        <PageHeader icon="fas fa-history">
      <template #title>
        Riwayat Pengobatan Dokter {{ clinic_name }}
      </template>
      <template #subtitle>
        Tinjau daftar riwayat penanganan pasien oleh dokter
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <ModernFilterBar
              embedded
              :showTimeseries="false"
              :showPeriod="true"
              :searchText.sync="filter.name"
              searchPlaceholder="Cari Nama Dokter"
              :startDate.sync="filter.start_date"
              :endDate.sync="filter.end_date"
              @search-keyup="filterByName"
              @period-search="filterByPeriode"
              @period-reset="resetFilterPeriode"
            />

            <medhop-data-table
              summary-title="Riwayat Pengobatan Dokter"
              striped
              hover
              responsive
              class="mt-3"
              :items="items"
              :fields="fields">
              <template #cell(photo)='data'>
                <div class="d-flex justify-content-center align-items-center image-container">
                  <div class="doctor-avatar">
                    <img
                      class="image"
                      :src="data.item.photo">
                  </div>
                </div>
              </template>
              <template #cell(actions)="data">
                <div class="d-flex">
                  <b-button
                    size="sm"
                    class="mr-1 btn-info"
                    v-b-tooltip.hover
                    title="Perjanjian"
                    @click="$router.push({ path: '/doctor/doctor-appointment/' + data.item.id })"><i class="fas fa-tasks px-0"></i></b-button>
                </div>
              </template>
            </medhop-data-table>
            <medhop-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"></medhop-pagination>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import ModernFilterBar from "@/component/general/ModernFilterBar.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";

export default {

  components: {
    Card,
    ModernFilterBar
  },

  data() {
    return {
      // filter
      filter: {
        name: "",
        start_date: "",
        end_date: "",
      },
      // pagination
      perPage: 20,
      currentPage: 1,
      lastCurrentPage: 1,
      totalRows: 0,
      // table fields
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "photo",
          label: "Foto",
        },
        {
          key: "name",
          label: "Nama Dokter",
          sortable: true,
        },
        {
          key: "polyclinic_name",
          label: "Poliklinik",
          sortable: true,
        },
        {
          key: "treatment_count",
          label: "Jumlah Penanganan",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // table items
      items: [],
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    async pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      this.lastCurrentPage = page;
      await this.pagination();
    },

    resetFilterPeriode() {
      this.filter = validation.clearForm(this.filter);
      this.pagination();
    },

    filterByPeriode() {
      if (this.filter.name != "" || this.filter.start_date != '' || this.filter.end_date != '') {
        this.currentPage = 1
      } else {
        this.currentPage = this.lastCurrentPage
      }
      this.pagination();
    },

    filterByName() {
      debouncer(() => {
        if (this.filter.name != "" || this.filter.start_date != '' || this.filter.end_date != '') {
          this.currentPage = 1
        } else {
          this.currentPage = this.lastCurrentPage
        }
        this.pagination();
      }, 500)
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`;
      let response = await module.paginate(
        `doctors/get-treatment-history`,
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;

      let a, b;
      b = this.perPage * (this.currentPage - 1) + 1;
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a;
      }
      this.items = response.data;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dokter" },
      { title: "Riwayat Pengobatan" },
    ]);
    this.pagination();
  },

};
</script>
